import { ListSubheader, Tooltip } from "@material-ui/core";
import React, { useEffect, useMemo, useRef, useState } from "react";
import { WrapperComponent } from "../wrappers";
import { Transformador } from "./";

export const TransformadorOqt = ({name, caption, formik}) => {
  //console.log({name, caption, formik})
  return (
    <>
      {formik && formik.values && formik.values[name] && formik.values[name].length > 0 && 
        <>
          <ListSubheader style={{width:"100%"}} component="div" id="nested-list-subheader">
            {caption}
          </ListSubheader>
          {formik.values[name].map((item, index) => 
            <WrapperComponent 
              key={`transform-${index}`} 
              caption={item.nombre} 
              Field={<Transformador name={`${name}.${index}.value`} formik={formik} caption={`Parámetro ${item.nombre}`}/>}
              Tooltip={item.descripcion && (({children}) => <Tooltip title={item.descripcion} aria-label="add" placement="top">{children}</Tooltip>)}
            />
          )}
        </>
      }
    </>
  )
}
